<template>
    <form-fieldset :error="error">
        <textarea
            :id="id"
            v-model="model"
            :autocomplete="autocomplete"
            :rows="rows"
            :maxlength="maxLength"
            class="form-textarea"
            :class="fieldClass"
            @focus="event => $emit('focus', event)"
        />
    </form-fieldset>
</template>
<script>
import FormFieldset from './FormFieldset';
import formField from '@/mixins/formField';

export default {
    components: {
        FormFieldset,
    },

    mixins: [
        formField,
    ],

    props: {
        id: {
            type: String,
            default: null,
        },

        autocomplete: {
            type: String,
            default: null,
        },

        rows: {
            type: Number,
            default: null,
        },

        maxLength: {
            type: Number,
            default: null,
        },
    },
};
</script>
